import { useEffect, useRef, useState } from "react";
import { Html5Qrcode } from "html5-qrcode";
import { Camera, CameraOff } from "lucide-react";

export const QrScanner = ({ onScan }) => {
  const [on, setOn] = useState(false);
  const [error, setError] = useState("");
  const ref = useRef(null);
  const cb = useRef(onScan);
  cb.current = onScan;

  useEffect(() => {
    if (!on) return undefined;
    const scanner = new Html5Qrcode("loyalty-qr-reader");
    ref.current = scanner;
    let stopped = false;
    const stop = () => {
      if (stopped) return;
      stopped = true;
      scanner.stop().catch(() => {}).finally(() => scanner.clear());
    };
    scanner
      .start({ facingMode: "environment" }, { fps: 10, qrbox: 230 }, (text) => { stop(); setOn(false); cb.current(text); })
      .catch(() => { setError("Fotocamera non disponibile: consenti l'accesso o scrivi il codice"); setOn(false); });
    return stop;
  }, [on]);

  return (
    <div>
      <div id="loyalty-qr-reader" data-testid="loyalty-qr-reader" className={`overflow-hidden rounded-2xl bg-[#0B1F3A] ${on ? "min-h-[260px]" : "hidden"}`} />
      <button
        type="button"
        data-testid={on ? "loyalty-scan-stop" : "loyalty-scan-start"}
        onClick={() => { setError(""); setOn((v) => !v); }}
        className="mt-3 w-full inline-flex items-center justify-center gap-2 rounded-full bg-[#0B1F3A] text-white px-5 py-4 text-sm font-bold uppercase tracking-[0.12em] hover:bg-[#071528] transition-colors"
      >
        {on ? <><CameraOff className="w-4 h-4" /> Chiudi fotocamera</> : <><Camera className="w-4 h-4" /> Scansiona tessera</>}
      </button>
      {error && <p data-testid="loyalty-scan-error" className="text-xs text-[#C2410C] mt-2">{error}</p>}
    </div>
  );
};
